import type { AxiosError } from 'axios';

import { HttpError } from './HttpError';

export class AuthZeroError extends HttpError {
  constructor(error: unknown) {
    const axiosError = error as AxiosError<AuthZeroHttpError>;
    const errorMessage = axiosError.response?.data?.error_description;
    const message = errorMessage || axiosError.message;
    const code = axiosError.response?.status;

    super(message, code);
  }
}

export interface AuthZeroHttpError {
  error_description: string;
}
